import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const NoPageFound = () => {
  const { isAuthenticated, userType } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const requestedPath = searchParams.get("from");

  const homePath = !isAuthenticated
    ? userType === "hrms"
      ? "/hrms/login"
      : "/signin"
    : userType === "hrms"
      ? "/hrms/my-profile"
      : "/";
  return (
    <div className="px-xl-5 px-4 py-5">
      <div
        className="card border-0 shadow-sm mx-auto"
        style={{ maxWidth: "640px", borderRadius: "24px" }}
      >
        <div className="card-body p-4 p-md-5 text-center">
          <span className="badge bg-danger-subtle text-danger mb-3">
            Error 404
          </span>
          <h1
            className="fw-bold mb-2"
            style={{ fontSize: "clamp(4rem, 12vw, 7rem)", lineHeight: 1 }}
          >
            404
          </h1>
          <h3 className="fw-semibold mb-3">Page not found</h3>
          <p className="text-muted mb-4">
            The page you are looking for does not exist, may have moved, or the
            URL might be incorrect.
          </p>
          {requestedPath ? (
            <p className="small text-muted mb-4">
              Requested path: <code>{requestedPath}</code>
            </p>
          ) : null}

          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Link className="btn btn-primary px-4" to={homePath}>
              Go to dashboard
            </Link>
            <Link className="btn btn-outline-secondary px-4" to="/signin">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoPageFound;
